<ng-container [formGroup]="form">
  <div class="form-group" [hidden]="form?.disabled">
    <div class="form-row">
      <div
        class="form-group col-md-6"
        [hidden]="form.get('productType')?.disabled"
      >
        <app-dc-select
          id="productType"
          [label]="labels.summary.productType"
          closeOnSelect="true"
          formControlName="productType"
          [items]="productTypeItems"
          class="productSelect"
          placeholder="Product Type"
          [clearSelection]="true"
        ></app-dc-select>
      </div>
      <div
        class="form-group col-md-6"
        [hidden]="form.get('recordStatus')?.disabled"
      >
        <app-dc-select
          id="recordStatus"
          [label]="labels.summary.recordStatus"
          closeOnSelect="true"
          formControlName="recordStatus"
          [items]="statusItems | async"
          placeholder="Status"
          [readonly]="'CHANGE_PRODUCT_STATUS' | restricted"
          (optionClicked)="openRecordWorkflowIfRequired($event)"
        ></app-dc-select>
      </div>
    </div>
    <div
      class="form-group"
      *ngIf="form.get('productName') as productName"
      [hidden]="productName.disabled"
    >
      <app-dc-input
        [label]="labels.summary.productName"
        [id]="'productName'"
        type="text"
        formControlName="productName"
        [loading]="productName.pending"
        [customErrorMessage]="
          productName.errors?.notUnique
            ? 'Another product already has this name'
            : ''
        "
      ></app-dc-input>
    </div>
    <div class="form-row">
      <div
        class="form-group col-md-6"
        *ngIf="form.get('isin') as isin"
        [hidden]="isin.disabled"
      >
        <app-dc-input
          [label]="labels.summary.isin"
          [id]="'isin'"
          type="text"
          [pattern]="'[A-Za-z]{2}[A-za-z0-9]{9}\\d'"
          [loading]="isin.pending"
          [helpText]="
            '12 character code. First 2 character are a country code. Next 9 is the unique number and the last number a check sum.'
          "
          formControlName="isin"
          [customErrorMessage]="getISINErrorMessage()"
        ></app-dc-input>
      </div>
      <div
        class="form-group col-md-6"
        [hidden]="form.get('currency')?.disabled"
      >
        <app-dc-select
          id="currency"
          [label]="labels.summary.currency"
          [labelId]="'currency'"
          [items]="currencyItems"
          closeOnSelect="true"
          searchable="true"
          formControlName="currency"
          [clearSelection]="true"
        ></app-dc-select>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-6" [hidden]="form.get('tenor')?.disabled">
        <app-dc-input
          [label]="labels.summary.tenor"
          [id]="'tenor'"
          type="text"
          [pattern]="'[0-9]{1,3}[dmywDMYW]{1}'"
          [helpText]="
            'Format is NNNT where NNN is a number and T is a type:<br><br>D = numbers 1 to 365 only<br>M = numbers 1 to 12 only<br>Y = numbers 1 to 99 only<br>W = numbers 1 to 52 only.'
          "
          formControlName="tenor"
          customErrorMessage="Please use correct formatting e.g. 1D, 3W, 5M, or 2Y"
        ></app-dc-input>
      </div>
      <div
        class="form-group col-md-6"
        [hidden]="form.get('frequency')?.disabled"
      >
        <app-dc-select
          [label]="labels.summary.frequency"
          [labelId]="'frequency'"
          [items]="frequencyItems"
          [searchable]="true"
          closeOnSelect="true"
          formControlName="frequency"
          [FreeText]="true"
          [clearSelection]="true"
        ></app-dc-select>
      </div>
    </div>
    <div class="form-row">
      <div
        class="form-group col-md-6"
        *ngIf="form.get('performanceType') as performanceType"
        [hidden]="performanceType.disabled"
      >
        <app-dc-select
          [label]="labels.summary.performanceType"
          [labelId]="'performanceType'"
          [items]="
            performanceTypeItems
              | filterPerformanceType
                : underlyingAssetsGroup.get('underlyingAssets').value
          "
          closeOnSelect="true"
          formControlName="performanceType"
          [clearSelection]="true"
          [readonly]="form.get('productType').value === 'CLN'"
        ></app-dc-select>
      </div>
      <div
        class="form-group col-md-6"
        *ngIf="form.get('settlementType') as settlementType"
        [hidden]="settlementType.disabled"
      >
        <app-dc-select
          [label]="labels.summary.settlementType"
          [warning]="
            isSettlementWarning()
              ? 'You selected Physical settlement but your underlying asset selection includes one or more Indices'
              : ''
          "
          [labelId]="'settlementType'"
          [items]="settlementTypeItems"
          closeOnSelect="true"
          formControlName="settlementType"
          [clearSelection]="true"
          [readonly]="settlementType.readOnly"
        ></app-dc-select>
      </div>
    </div>
  </div>
  <ng-container formGroupName="underlyingAssetsGroup">
    <div class="form-group" [hidden]="underlyingAssetsGroup?.disabled">
      <h3>
        {{ underlyingAssetsLabel }}
      </h3>
      <div
        *ngIf="
          underlyingAssetsGroup.get('underlyingAssets') as underlyingAssets
        "
        class="form-group"
      >
        <app-dc-asset-display
          [label]="underlyingAssetsLabel"
          [labelId]="'underlyingAssets'"
          closeOnSelect="true"
          formControlName="underlyingAssets"
          multiple="true"
          checkbox="true"
          [readonly]="true"
          [editButton]="canUserEdit"
          (editEvent)="openUnderlyingAssetsModal()"
        ></app-dc-asset-display>
      </div>
    </div>
  </ng-container>
  <div
    class="form-group"
    [hidden]="form.get('referenceEntitiesDisplay')?.disabled"
  >
    <div class="subheadDiv">
      <h3>{{ labels.summary.referenceEntities.referenceEntityObligation }}</h3>
      <button
        type="button"
        class="editButton btn btn-link editKeyDatesButton"
        (click)="openReferenceModal()"
        *ngIf="canUserEdit"
      >
        Edit
      </button>
    </div>
    <div class="form-row">
      <app-dc-reference-display
        [label]="labels.summary.referenceEntities.referenceEntity"
        [items]="selectedReferenceEntities$ | async"
      ></app-dc-reference-display>
    </div>
  </div>

  <ng-container formGroupName="keyDates">
    <div class="form-group" [hidden]="form.get('keyDates')?.disabled">
      <div class="subheadDiv">
        <h3>{{ labels.summary.keyDates.keyDates }}</h3>
        <button
          type="button"
          class="editButton btn btn-link editKeyDatesButton"
          (click)="openKeyDatesModal()"
          *ngIf="canUserEdit"
        >
          Edit
        </button>
      </div>
      <div class="form-row">
        <ng-container formGroupName="issueDate">
          <div
            class="form-group col-md-6"
            *ngIf="keyDatesGroup.get('issueDate') as issueDate"
            [hidden]="issueDate.disabled"
          >
            <app-dc-date-input
              [label]="labels.summary.keyDates.issueDate"
              id="issueDate"
              type="text"
              placeholder=""
              formControlName="value"
              container="body"
              [readonly]="issueDate.get('value').readOnly"
              customErrorMessage="Please enter date in DD/MM/YYYY format"
            ></app-dc-date-input>
          </div>
        </ng-container>
        <ng-container formGroupName="redemptionDate">
          <div
            class="form-group col-md-6"
            *ngIf="keyDatesGroup.get('redemptionDate') as redemptionDate"
            [hidden]="redemptionDate.disabled"
          >
            <app-dc-date-input
              [label]="labels.summary.keyDates.redemptionDate"
              [id]="'redemptionDate'"
              type="text"
              placeholder=""
              formControlName="value"
              container="body"
              [readonly]="redemptionDate.get('value').readOnly"
            ></app-dc-date-input>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</ng-container>
